import React from 'react';
import { Dropdown, Popover } from 'rsuite';
import { RowData } from '../../../../../../../../../reducers/OtimizacaoPrecos/optimizationPricesList';
import { IAComponent } from '../../../../../OtimizacaoPrecos/components/CoordinateSection/ia';

export enum DropdownEventKey {
  'edit-optimization' = 'edit-optimization',
  'delete-optimization' = 'delete-optimization',
  'result-optimization' = 'result-optimization',
  'optimization-summary' = 'optimization-summary',
}

interface MenuProps {
  onSelect: (eventKey: string, event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  rowData: RowData;
}
const Menu = ({ onSelect, rowData }: MenuProps) => {
  const isActive = rowData.status === 'ativa';
  return (
    <Dropdown.Menu onSelect={onSelect}>
      <Dropdown.Item eventKey={DropdownEventKey['result-optimization']}>Acompanhar resultado</Dropdown.Item>
      {isActive && <Dropdown.Item eventKey={DropdownEventKey['edit-optimization']}>Editar otimização</Dropdown.Item>}
      <Dropdown.Item eventKey={DropdownEventKey['delete-optimization']}>Excluir</Dropdown.Item>
      <Dropdown.Item eventKey={DropdownEventKey['optimization-summary']}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          Resumo da otimização
          <IAComponent />
        </div>
      </Dropdown.Item>
    </Dropdown.Menu>
  );
};

interface TableOptionsProps {
  onSelect: (eventKey: string, event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  rowData: RowData;
}

export const TableOptions = ({ onSelect, rowData, ...rest }: TableOptionsProps) => (
  <Popover {...rest} full>
    <Menu onSelect={onSelect} rowData={rowData} />
  </Popover>
);
